// extracted by mini-css-extract-plugin
export default {"bannerLink":"WX5NOIBZ3holIh2hpPBJ","bannerImage":"vXzXbGbv4PjardhNJtaD"};